import { render } from "./SearchHolder.vue?vue&type=template&id=26b58817"
import script from "./SearchHolder.vue?vue&type=script&lang=js"
export * from "./SearchHolder.vue?vue&type=script&lang=js"

import "./SearchHolder.vue?vue&type=style&index=0&id=26b58817&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__